/**
 * 두 날짜 간의 일(day) 차이를 계산
 * @param {Date} todayObj - 오늘 날짜 객체 (예: new Date())
 * @param {string} newsDateStr - 뉴스 날짜 문자열 (예: "2025.10.15")
 * @returns {number|null} - 날짜 차이 (며칠 전인지), 파싱 실패 시 null
 */

export const getDaysDiff = (todayObj, newsDateStr) => {
    if (!todayObj || !newsDateStr) return null;

    // "YYYY.MM.DD" 형식 추출
    const match = newsDateStr.match(/\d{4}\.\d{2}\.\d{2}/);
    if (!match) return null;

    const [y, m, d] = match[0].split(".").map(Number);

    // 뉴스 날짜 및 오늘 날짜 생성
    const newsDate = new Date(y, m - 1, d);
    const todayDate = new Date(todayObj.getFullYear(), todayObj.getMonth(), todayObj.getDate());

    // 일 단위 차이 계산
    const diffTime = todayDate.getTime() - newsDate.getTime();
    return Math.floor(diffTime / (1000 * 60 * 60 * 24));
};
